(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6219],{

/***/ 11587:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[slug]",
      function () {
        return __webpack_require__(87411);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 87411:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/common/Buttons/PrimaryButton.tsx
var PrimaryButton = __webpack_require__(29204);
// EXTERNAL MODULE: ./components/common/CallToAction/FooterCallToAction.tsx + 1 modules
var FooterCallToAction = __webpack_require__(24035);
// EXTERNAL MODULE: ./components/common/CallToAction/OSSCallToAction.tsx
var OSSCallToAction = __webpack_require__(42698);
// EXTERNAL MODULE: ./components/common/Footer/Footer.tsx + 1 modules
var Footer = __webpack_require__(5945);
// EXTERNAL MODULE: ./components/common/Navbar/Navbar.tsx + 4 modules
var Navbar = __webpack_require__(93890);
// EXTERNAL MODULE: ./components/common/Section/Section.tsx
var Section = __webpack_require__(62223);
// EXTERNAL MODULE: ./components/common/Typography/Typography.tsx
var Typography = __webpack_require__(20026);
// EXTERNAL MODULE: ./components/Home/CompaniesReel/CompaniesReel.tsx + 5 modules
var CompaniesReel = __webpack_require__(92905);
// EXTERNAL MODULE: ./components/Home/CustomerReviewTrack.tsx
var CustomerReviewTrack = __webpack_require__(63519);
// EXTERNAL MODULE: ./components/Home/Home.module.scss
var Home_module = __webpack_require__(19350);
var Home_module_default = /*#__PURE__*/__webpack_require__.n(Home_module);
// EXTERNAL MODULE: ./components/Home/LandingInfoRow.tsx
var LandingInfoRow = __webpack_require__(3560);
// EXTERNAL MODULE: ./node_modules/react-icons/md/index.esm.js
var index_esm = __webpack_require__(5434);
;// CONCATENATED MODULE: ./public/images/features/sessionReplayHero.png
/* harmony default export */ var sessionReplayHero = ({"src":"/_next/static/media/sessionReplayHero.7e615733.png","height":1872,"width":1714,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAMAAAAC2hU0AAAAWlBMVEVMaXHUzub19PamoLTGs/bz8/Pl5ejv7/L6+vrbz/cDABbXz+2bePXq5vPn5ujq6evm5OjNy89xa31JQlvs6PL////v6f708/bv7vDq6ustJkQhHDaxrL95cJKiKi6cAAAAF3RSTlMAzyL5Qdr++Pxx/Z0X8bWFUf7++qtIdKxwtKQAAAAJcEhZcwAAFiUAABYlAUlSJPAAAAA+SURBVAiZFcEHEoAgDATAowsW7JeA/v+bjruw4bwvC6yRz+sMqg5H6Q0LubdeEJg0bg6JokLC59HMQvwmnz9prQMbQn4mfwAAAABJRU5ErkJggg==","blurWidth":7,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/features/errorMonitoringHero.png
/* harmony default export */ var errorMonitoringHero = ({"src":"/_next/static/media/errorMonitoringHero.07dcba1e.png","height":1982,"width":1841,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAMAAAAC2hU0AAAAPFBMVEX29vb7+/z19fX+/v75+fvj2f15Rf7///7s7O3z8vXn3/r39/fk2vv////////z8vP////azPzu6fvh4OP43CQBAAAAE3RSTlP+/c94/SMC/v39u6+EAkzaQ1nh9pxdjgAAAAlwSFlzAAAWJQAAFiUBSVIk8AAAADhJREFUCJkFwYkBgCAMBMHlSY4Aipr+e3UGO6vddvGMzMxKI2IMWAQQ1JCkQkdChT2/Hl24u717/jlgAashtxebAAAAAElFTkSuQmCC","blurWidth":7,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/features/loggingHero.png
/* harmony default export */ var loggingHero = ({"src":"/_next/static/media/loggingHero.e5bd46a4.png","height":2137,"width":1892,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAMAAAAC2hU0AAAAP1BMVEXq6ez39vbu7e/08/VMaXGad/X////v7vD09PT+/v7Jt/jp5PZXFf/UyfC1nPXh2fXPwPT4+fb39vjf2u349/o+gyLHAAAAFHRSTlP+R7zJACUW+v3+ZdwJsUvjfbZ4euEWGIAAAAAJcEhZcwAAFiUAABYlAUlSJPAAAAA6SURBVAiZFchJDsAgDANAA4bE3Vv8/7dWnEYasNZZBjECcDaUzLCNL1cI71LCHoiU0K/nvG2Q5NG3HzeQAdy3TpeFAAAAAElFTkSuQmCC","blurWidth":7,"blurHeight":8});
// EXTERNAL MODULE: ./components/Animate.tsx
var Animate = __webpack_require__(60216);
;// CONCATENATED MODULE: ./pages/[slug].tsx





















const ShowcasePage = (param)=>{
    let { feature  } = param;
    var ref;
    const [imageLoaded, setImageLoaded] = (0,react.useState)(false);
    const subHeader2List = [
        /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "Debug from a ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "text-color-selected-light",
                    children: "user's"
                }),
                " perspective."
            ]
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "Uncover the issues ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "text-color-selected-light",
                    children: "user's"
                }),
                " face."
            ]
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "Search & set alerts ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "text-color-selected-light",
                    children: "across your logs."
                })
            ]
        })
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: sessionReplayHero,
                alt: "Hero Background",
                className: "hidden"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: errorMonitoringHero,
                alt: "Hero Background",
                className: "hidden"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: loggingHero,
                alt: "Hero Background",
                className: "hidden"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "hidden md:flex ml-10 my-2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                        type: "copy3",
                        emphasis: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center justify-start gap-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdKeyboardReturn */.Su7, {
                                    className: "h-5"
                                }),
                                " Explore highlight.io"
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col xl:flex-row justify-between w-screen px-8 mx-auto lg:px-4 lg:py-28 max-w-[1200px] 2xl:max-w-[1400px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "lg:w-1/2 flex justify-center mt-10",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col max-w-4xl gap-8 text-center lg:text-left",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            className: "text-white",
                                            children: feature.header
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                            type: "copy1",
                                            className: "text-copy-on-dark",
                                            children: feature.subheader
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex flex-col lg:flex-row justify-start gap-4 w-full lg:w-auto",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PrimaryButton/* PrimaryButton */.K, {
                                                    className: classnames_default()((Home_module_default()).solidButton, "min-w-[180px]"),
                                                    href: "https://app.highlight.io/?sign_up=1",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                                        type: "copy2",
                                                        emphasis: true,
                                                        children: "Get started"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PrimaryButton/* PrimaryButton */.K, {
                                                    href: feature.docsLink,
                                                    className: classnames_default()((Home_module_default()).hollowButton),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                                        type: "copy2",
                                                        emphasis: true,
                                                        children: "Read our docs"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex justify-center mt-12 lg:mt-0 ultra:relative",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Animate/* AnimateFeatureHeroRight */.kg, {
                                        loaded: imageLoaded,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            className: "hidden lg:flex ultra:hidden right-0 object-contain top-0",
                                            src: feature.slantedImage,
                                            alt: "Feature Spotlight",
                                            onLoadingComplete: ()=>setImageLoaded(true)
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Animate/* AnimateFeatureHeroXL */.lp, {
                                        loaded: imageLoaded,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            className: "hidden ultra:flex",
                                            src: feature.regularImage,
                                            alt: "Feature Spotlight",
                                            onLoadingComplete: ()=>setImageLoaded(true)
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "lg:hidden right-0 object-contain bottom-0 md:w-[500px]",
                                        src: feature.regularImage,
                                        alt: "Feature Spotlight",
                                        onLoadingComplete: ()=>setImageLoaded(true)
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-full mx-auto max-w-screen-2xl mt-24 lg:mt-60",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* Section */.$, {
                            className: "flex flex-col gap-20",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "mx-auto max-w-[1100px]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: "self-center text-center",
                                        children: subHeader2List[feature.header2Selection]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "px-8 max-w-[700px] mx-auto mt-6 text-center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                            type: "copy1",
                                            className: "text-copy-on-dark text-center",
                                            children: feature.subheader2
                                        })
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()((Home_module_default()).infoContainer, ""),
                        children: (ref = feature.infoRows) === null || ref === void 0 ? void 0 : ref.map((row, index)=>{
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingInfoRow/* default */.Z, {
                                title: row.header,
                                desc: row.subheader,
                                link: row.link,
                                linkText: row.linkText,
                                privacy: row.privacy || false,
                                imgSrc: row.imgSrc || "",
                                invert: row.invert,
                                code: row.code,
                                codeFrom: row.codeFrom
                            }, index);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OSSCallToAction/* OSSCallToAction */.N, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* Section */.$, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CompaniesReel/* CompaniesReel */.T, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* Section */.$, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Home_module_default()).anchorFeature,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Home_module_default()).anchorHead,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* Typography */.Z, {
                                    type: "copy2",
                                    onDark: true,
                                    children: [
                                        "Don't take our word. ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/customers",
                                            children: "Read our customer review section →"
                                        })
                                    ]
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomerReviewTrack/* CustomerReviewTrack */.W, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterCallToAction/* FooterCallToAction */.Z, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {})
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var _slug_ = (ShowcasePage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5445,4617,6556,1228,3826,1399,5675,8250,1142,7122,7726,4003,7594,8558,8616,9774,2888,179], function() { return __webpack_exec__(11587); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);